// extracted by mini-css-extract-plugin
module.exports = {"block":"Partners_block__ZPMz_","container":"Partners_container__3Foam","title":"Partners_title__V3ouS","logos":"Partners_logos__2s_kZ","logo":"Partners_logo__3ac_m"};